import Nav from "react-bootstrap/Nav";
import { Link, NavLink } from "react-router-dom";

export const Sidebar: React.FC<{
  style?: React.CSSProperties;
  categories: { id: string; name: string }[];
}> = ({ style, categories }) => (
  <Nav
    className="flex-column bg-dark sidebar px-3 py-5"
    activeKey="/"
    variant="pills"
    style={style}
  >
    <Nav.Item className="mb-4">
      <Nav.Link as={NavLink} to="/">
        Home
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link as="span" className="fw-bold">
        Categories
      </Nav.Link>
    </Nav.Item>
    {categories.map(({ name, id }) => (
      <Nav.Item>
        <Nav.Link as={NavLink} to={`/category/${id}`}>
          {name}
        </Nav.Link>
      </Nav.Item>
    ))}
    <div className="flex-grow-1"></div>
    <Nav.Item>
      <Nav.Link
        className="fw-bold mb-3"
        as={NavLink}
        to={`/tasks/manageCategories`}
      >
        Manage categories
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link className="fw-bold mb-3" as={NavLink} to={`/tasks/manageTags`}>
        Manage tags
      </Nav.Link>
    </Nav.Item>
  </Nav>
);
